module.exports = __webpack_public_path__ + "img/terry-gallery-2.4d5a0f8b.jpg";